import * as React from 'react';

import type {User} from 'nutshell-core/types';

import {PageContentTwoColumn} from 'shells/layout/page-content-two-column';

import {PageContainer, PageTitleBar} from '../../../layout';
import {SettingsSidebar} from '../../../setup/settings-sidebar';

import {SEOScanPageContent} from './seo-scan-page-content';

import styles from './seo-scan-page.module.css';

type Props = {
    user: User | null | undefined;
};

export function SEOScanPage(props: Props) {
    return (
        <PageContainer
            title='Free SEO scan'
            noPadding={true}
            pageTitleBar={
                <PageTitleBar
                    title='Free SEO scan'
                    subheaderPrimaryText='Get results in less than two minutes! Enter your URL below to get started.'
                />
            }
        >
            <PageContentTwoColumn
                leftContent={<SEOScanPageContent user={props.user} />}
                rightContent={
                    <div className={styles['cue-cards-container']}>
                        <SettingsSidebar />
                    </div>
                }
            />
        </PageContainer>
    );
}
